import {
  AssessmentStatusSchema,
  type AssessmentStatus,
} from "../types/assessment.js";
import { isAssessmentStatusUnderWay } from "./isAssessmentStatusUnderWay.js";

/**
 * The statuses `isAssessmentStatusUnderWay` holds of, so a query selects by the
 * same shared rule.
 */
export const assessmentStatusesUnderWay: readonly AssessmentStatus[] =
  AssessmentStatusSchema.options.filter(isAssessmentStatusUnderWay);
